<template>
  <div>
    <b-dropdown variant="link" class="p-0" no-caret :right="$store.state.appConfig.isRTL">
      <template #button-content>
        <feather-icon icon="MoreVerticalIcon" size="20" class="align-middle text-body" />
      </template>

      <b-dropdown-item v-if="canUpdateUser" :to="{ name: 'admin-update-patient', params: { id: getValueFromSource(userData, '_id') } }">
        <feather-icon icon="EditIcon" />
        <span class="align-middle ml-50">Edit</span>
      </b-dropdown-item>

      <!-- <b-dropdown-item v-if="canDeactivateUser" @click="onDeactivateUser">
        <feather-icon class="text-danger" icon="Trash2Icon" />
        <span class="align-middle text-danger ml-50">Deactivate</span>
      </b-dropdown-item> -->
    </b-dropdown>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BCardHeader,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BBadge,
  BButton,
  BRow,
  BCol,
  BCardImg,
  BLink
} from 'bootstrap-vue';
import {
  get
} from "lodash";

import Ripple from 'vue-ripple-directive';
import VueEasyLightbox from 'vue-easy-lightbox';

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BCardImg,
    BLink,
    VueEasyLightbox
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageLoading: true,
      visible: false,
      index: 0, // default: 0
    }
  },
  computed: {
    canUpdateUser() {
      return this.can("users:CanUpdate");
    },
    canDeactivateUser() {
      return this.can("users:CanDeactivate") && !this.isDriver;
    },
  },
  methods: {
    async onDeactivateUser() {
      try {
        this.loading = true;

        const result = await this.$swal({
          title: 'Confirm Account Deactivate?',
          text: "Are you sure you want to deactivate this account?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, deactivate!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.value) {
          return;
        }

        const user_id = this.userData._id;
        if (!user_id) {
          return;
        }

        await this.useJwt().mainService.deactivateUser(user_id);
        this.$emit("refresh")
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>
